import { Map } from 'immutable';

export default function getTaskById(taskId = '') {
  return (state: any) => {
    return state.getIn(['apiTask', 'data', 'byId', taskId], Map()) || Map();
  };
}
